// components/variant-table/GroupInventoryInput.jsx
import React, { useEffect, useState } from "react";

export default function GroupInventoryInput({
  groupName,
  comboGroup,
  comboList,
  setComboList,
  hasSubVariants,
}) {
  const baseVariant = comboGroup[0];
  const variantUiId = baseVariant.variantUiId;
  const baseTracked = !!baseVariant.trackInventory;

  // Editable if no sub-variants
  const isEditable = !hasSubVariants;

  // Compute total tracked inventory from sub-variants
  const totalTracked = comboGroup.reduce((acc, curr) => {
    if (!curr.trackInventory) return acc;
    const n = parseInt(curr.inventoryQuantity);
    return acc + (isNaN(n) ? 0 : n);
  }, 0);
  const allUntracked = comboGroup.every((c) => !c.trackInventory);

  // Formatting helpers
  const formatWithCommas = (n) => {
    if (n === null || n === undefined || n === "") return "";
    const v = parseInt(String(n).replace(/,/g, ""), 10);
    if (isNaN(v)) return "";
    return v.toLocaleString();
  };

  const [tempValue, setTempValue] = useState("");

  // Sync temp value from comboList
  useEffect(() => {
    const current = baseVariant.inventoryQuantity;
    setTempValue(
      typeof current === "number" && isFinite(current) ? formatWithCommas(current) : ""
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [baseVariant.inventoryQuantity, baseTracked, variantUiId]);

  const handleChange = (e) => {
    // allow digits only while typing
    const digits = String(e.target.value || "").replace(/\D/g, "");
    setTempValue(digits);
  };

  const handleBlur = () => {
    const digits = String(tempValue || "").replace(/\D/g, "");
    if (digits === "") {
      // allow empty; don't change state to commas, keep empty
      setComboList((prev) =>
        prev.map((combo) =>
          combo.variantUiId === variantUiId
            ? {
                ...combo,
                inventoryQuantity: "",
                meta: { ...(combo.meta || {}), inventoryDirty: true },
              }
            : combo
        )
      );
      setTempValue("");
      return;
    }

    const value = parseInt(digits, 10);
    if (isNaN(value) || value < 0) {
      setTempValue("");
      return;
    }

    setComboList((prev) =>
      prev.map((combo) =>
        combo.variantUiId === variantUiId
          ? {
              ...combo,
              inventoryQuantity: value,
              meta: { ...(combo.meta || {}), inventoryDirty: true },
            }
          : combo
      )
    );
    setTempValue(formatWithCommas(value));
  };

  return (
    <div className="flex-1 max-w-[7em]" onClick={(e) => e.stopPropagation()}>
      {isEditable ? (
        baseTracked ? (
          <input
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            className="border border-[#8e8e8e] w-full py-[5px] px-[5px] rounded text-[14px] font-medium bg-[#ffffff]"
            value={tempValue}
            onChange={handleChange}
            onBlur={handleBlur}
            onKeyDown={(e) => {
              if (["e", "E", "+", "-", "."].includes(e.key)) {
                e.preventDefault();
              }
            }}
            placeholder="0"
          />
        ) : (
          <input
            type="text"
            value="--"
            disabled
            className="border border-[#8e8e8e] w-full py-[5px] px-[5px] rounded text-[14px] text-[#8c8c8c] font-medium bg-[#efefef] cursor-not-allowed"
          />
        )
      ) : (
        <input
          type="text"
          value={allUntracked ? '--' : formatWithCommas(totalTracked)}
          disabled
          className="border border-[#8e8e8e] w-full py-[5px] px-[5px] rounded text-[14px] text-[#8c8c8c] font-medium bg-[#efefef] cursor-not-allowed"
        />
      )}
    </div>
  );
};
